'use client';

import { Swiper, SwiperSlide } from 'swiper/react';

import AllCasesCard from './AllCasesCard';

import { ArticleCard } from '@/shared/components/articleCard';

interface MobileSliderProps {
  className?: string;
  articlesCards: {
    chips: string[];
    img: string;
    alt: string;
    label: string;
    tags: string[];
    urlArticle: string;
    width: number;
    height: number;
  }[];
  allCasesCardProps: {
    link: string;
    text: string;
    bgUrl: string;
  };
}

const MobileSlider: React.FC<MobileSliderProps> = ({
  articlesCards,
  className,
  allCasesCardProps,
}) => (
  <div className={className}>
    <Swiper
      spaceBetween={12}
      slidesPerView={1}
      breakpoints={{ 640: { slidesPerView: 2 } }}
      className="!px-8"
    >
      {articlesCards.map((cards, index) => (
        <SwiperSlide key={index}>
          <ArticleCard {...cards} />
        </SwiperSlide>
      ))}
      <SwiperSlide>
        <AllCasesCard {...allCasesCardProps} />
      </SwiperSlide>
    </Swiper>
  </div>
);

export default MobileSlider;
